import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef
} from '@angular/core';
import { ICON_TYPE, LaunchDialogService } from '@spartacus/storefront';
import { GonvarriProduct } from '../../core/models/gonvarri-product.model';
import { take } from 'rxjs/operators';
import { GonvarriQuickStockNotificationEvent } from '../../core/events/gonvarri-quick-stock-notification-event';
import { QuickStockAdapterImpl } from '../../core/adapters/quick-stock.adapter';

@Component({
  selector: 'app-gonvarri-product-nofification-button',
  standalone: false,
  templateUrl: './gonvarri-product-nofification-button.component.html',
  styleUrl: './gonvarri-product-nofification-button.component.scss'
})
export class GonvarriProductNofificationButtonComponent implements OnChanges {

  @Input() product!: GonvarriProduct;
  protected readonly ICON_TYPE = ICON_TYPE;
  notificationRegistered = false;
  loading = false;

  constructor(
    protected launchDialogService: LaunchDialogService,
    protected quickStockAdapter: QuickStockAdapterImpl,
    protected cdr: ChangeDetectorRef
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['product'] && this.product?.code) {
      this.refreshNotificationStatus();
    }
  }

  generateStockNotificationEventData(product: GonvarriProduct, channel?: string): GonvarriQuickStockNotificationEvent {
    const quickStockNotificationEvent = new GonvarriQuickStockNotificationEvent();
    quickStockNotificationEvent.productCode = product.code as string;
    quickStockNotificationEvent.channel = channel;
    return quickStockNotificationEvent;
  }

  openDialog(): void {
    const eventData = this.generateStockNotificationEventData(this.product);

    const dialog = this.launchDialogService.openDialog(
      'GONVARRI_QUICK_STOCK_NOTIFICATION',
      undefined,
      undefined,
      eventData
    );

    if (dialog) {
      dialog.pipe(take(1)).subscribe(() => {
        this.refreshNotificationStatus();
      });
    }
  }

  refreshNotificationStatus(): void {
    if (!this.product?.code) {
      return;
    }

    this.loading = true;

    this.quickStockAdapter.getStockNotification(this.product.code).subscribe({
      next: (data) => {
        this.notificationRegistered = !!data[0]?.removeUrl;
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.loading = false;
        this.cdr.detectChanges();
      }
    });
  }

  get notificationLabel(): string {
    return this.notificationRegistered
      ? 'gonvarri.product.cancelNotification'
      : 'gonvarri.product.notification';
  }
}
